<template>
  <ModalMessage
    v-model="modal"
    :noCancelButton="false"
    :noCancelIcon="false"
    :noIcon="false"
    :iconClass="modal.iconClass"
    :iconColor="modal.iconColor"
    :backdrop="modal.backdrop"
    @close="onCancel"
  >
    <template #content>
      <div class="text-center items-center justify-center px-12 py-5">
        <button
          class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          @click="onCancel"
        >✕</button>

        <div class="flex justify-center mb-2" v-if="!modal.noIcon">
          <div class="w-12 h-12 rounded-full bg-warning/20 flex items-center justify-center">
            <i class="bi text-[24px] font-bold" :class="`bi-${modal.iconClass} text-${modal.iconColor}`"></i>
          </div>
        </div>

        <h2 class="text-lg font-semibold text-center">{{ modal.title }}</h2>
        <!-- Permitimos \n o HTML: -->
        <p class="py-4 text-sm whitespace-pre-line" v-html="modal.message"></p>

        <!-- ✅ NEW: Optional form fields -->
        <div v-if="hasForm" class="mt-2 text-left space-y-3">
          <div v-for="f in modal.form.fields" :key="f.key" class="form-control">
            <label class="label">
              <span class="label-text">
                {{ f.label }}
                <span v-if="f.required" class="text-error">*</span>
              </span>
            </label>

            <!-- text input (your current need: description) -->
            <input
              v-if="(f.type ?? 'text') === 'text'"
              class="input input-bordered w-full"
              :placeholder="f.placeholder ?? ''"
              v-model="modal.formValues[f.key]"
            />

            <!-- textarea (optional support, nice for "description") -->
            <textarea
              v-else-if="f.type === 'textarea'"
              class="textarea textarea-bordered w-full"
              :placeholder="f.placeholder ?? ''"
              v-model="modal.formValues[f.key]"
              rows="3"
            />

            <!-- fallback to text -->
            <input
              v-else
              class="input input-bordered w-full"
              :placeholder="f.placeholder ?? ''"
              v-model="modal.formValues[f.key]"
            />
          </div>
        </div>

        <div class="modal-action flex gap-4">
          <button class="flex-1 btn btn-default" @click="onCancel">{{ modal.cancelText }}</button>
          <button class="flex-1 btn btn-primary" @click="onConfirm" :disabled="!isValid">{{ modal.confirmText }}</button>
        </div>
      </div>
    </template>
  </ModalMessage>
</template>

<script setup>
import { computed } from 'vue'
import ModalMessage from '@/components/atoms/ModalMessage.vue'
import { confirmState, resolveConfirm } from '@/common/confirms.js'

const modal = computed({
  get: () => confirmState,
  set: (v) => (confirmState.show = v.show),
})

const hasForm = computed(() => Array.isArray(modal.value.form?.fields) && modal.value.form.fields.length > 0)

// If you don’t want any validation, replace `isValid` with `true`
const isValid = computed(() => {
  if (!hasForm.value) return true
  return modal.value.form.fields.every((f) => {
    if (!f.required) return true
    const v = modal.value.formValues?.[f.key]
    return String(v ?? '').trim().length > 0
  })
})

function onCancel() { resolveConfirm(false) }
function onConfirm() { resolveConfirm(true, { ...(modal.value.formValues || {}) }) }
</script>
